import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import { navigate } from "raviger";
import { Field, Form, Formik, } from 'formik';
import Select from 'react-select';
import moment from 'moment';
import { Switch } from 'formik-mui';
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Form as BootstrapForm,
  FormGroup,
  Row,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowAltCircleLeft,
} from '@fortawesome/free-solid-svg-icons';
import * as Yup from 'yup';
import Editor from 'react-simple-wysiwyg';
import { AuthContext } from "../accounts/AccountsReducer";
import { DateTimePicker, DropDown, TextInput } from '../components/Form';
import { SystemErrorContext } from '../components/SystemError';
import Patient from './components/Patient';

const customStyles = {
  // For the select it self, not the options of the select
  control: (styles, { isDisabled}) => {
    return {
      ...styles,
      color: '#FFF',
      cursor: isDisabled ? 'not-allowed' : 'default',
      backgroundColor: isDisabled ? '#DFDDDD' : 'white',
      // height: 35,
      minHeight: 35
    }
  },
  option: provided => ({
    ...provided,
    color: 'black'
  }),
  // singleValue: (styles, { isDisabled }) => ({
  //   ...styles,
  //   color: isDisabled ? '#595959' : 'black'
  // }),
};

const DischargeSummaryForm = ({medrecordid, id, incident, organization}) => {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  const [data, setData] = useState({id:null, name:'', description:'', open:null, assignee:null, medical_record:medrecordid, discharge_templates:[], vet_status:''});
  const [changeStatusOptions, setChangeStatusOptions] = useState([{value:'Discharged', label:'Discharged'},]);

  const [animalData, setAnimalData] = useState({});
  const [dischargeTemplates, setDischargeTemplates] = useState([]);
  const [assigneeChoices, setAssigneeChoices] = useState([]);

  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchDischargeSummary = async (animal_object, medical_plan) => {
      // Fetch Visit Note data.
      await axios.get('/vet/api/dischargesummary/' + id + '/', {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          response.data['discharge_templates'] = [];
          response.data['vet_status'] = animal_object.vet_status;
          response.data['medical_plan'] = medical_plan;
          setData(response.data);
        }
      })
      .catch(error => {
        setShowSystemError(true);
      });
    };

    if (medrecordid) {
      const fetchMedRecord = async () => {
        // Fetch MedRecord data.
        await axios.get('/vet/api/medrecord/' + medrecordid + '/', {
          cancelToken: source.token,
        })
        .then(response => {
          if (!unmounted) {
            if (id) {
              fetchDischargeSummary(response.data.animal_object, response.data.medical_plan);
            }
            else {
              // If this is a new Discharge, insert a row for each treatment.
              let treatments_string = '';
              response.data.treatment_plans.forEach(function(plan) {
                let last_tr = plan.treatment_requests.filter(request => request.status !== 'Not Administered').at('-1');
                let temp_string = '';
                if (last_tr) {
                  temp_string = 'Your animal received ' + plan.quantity + (plan.unit ? (' ' + plan.unit) + (Number(plan.quantity) !== 1 ? 's' : '') : "") + ' of ' + last_tr.treatment_object.description + ' while in our care.'
                }
                if (last_tr && last_tr.status === 'Completed') {
                  temp_string = temp_string + ' The last treatment was given at ' + moment(last_tr.actual_admin_time).format('MM/DD/YY HH:mm') + '.<br />';
                }
                else {
                  let next_tr = plan.treatment_requests.filter(request => ['Pending', 'Scheduled'].includes(request.status))[0];
                  if (next_tr) {
                    temp_string = temp_string + ' The next treatment is due at ' + moment(next_tr.suggested_admin_time).format('MM/DD/YY HH:mm');
                    temp_string = temp_string + (plan.treatment_requests.filter(request => ['Pending', 'Scheduled'].includes(request.status)).length > 1 && plan.frequency && plan.frequency > 0 ? (' and should be given again every ' + String(plan.frequency) + ' hours.<br />') : '.<br />');
                  }
                }
                treatments_string = treatments_string + temp_string;
              });
              // Add diagnostics.
              let diagnostic_string = 'Your animal received ';
              let first = true;
              response.data.diagnostic_objects.filter(diagnostic => diagnostic.status === 'Completed').forEach(function(diagnostic) {
                let temp_string = '';
                if (!first) {
                  temp_string = temp_string + ', ';
                }
                first = false;
                temp_string = temp_string + (diagnostic.other_name ? diagnostic.other_name : diagnostic.name);
                diagnostic_string = diagnostic_string + temp_string
              });
              if (response.data.diagnostic_objects.filter(diagnostic => diagnostic.status === 'Completed').length > 0) {
                treatments_string = treatments_string + diagnostic_string + ' while in our care.<br />';
              }
              // Add procedures.
              let procedure_string = 'Your animal received ';
              let prod_first = true;
              response.data.procedure_objects.filter(procedure => procedure.status === 'Completed').forEach(function(procedure) {
                let temp_string = '';
                if (!prod_first) {
                  temp_string = temp_string + ', ';
                }
                prod_first = false;
                temp_string = temp_string + (procedure.other_name ? procedure.other_name : procedure.name);
                procedure_string = procedure_string + temp_string
              });
              if (response.data.procedure_objects.filter(procedure => procedure.status === 'Completed').length > 0) {
                treatments_string = treatments_string + procedure_string + ' while in our care.<br />';
              }
              setData(prevState => ({ ...prevState, "vet_status":response.data.animal_object.vet_status, "medical_plan":response.data.medical_plan, "description":treatments_string}));
            }
            setAnimalData(response.data.animal_object);
            if (response.data.animal_object.vet_status !== 'Discharged') {
              setChangeStatusOptions([{value:response.data.animal_object.vet_status, label:response.data.animal_object.vet_status}, ...changeStatusOptions]);
            }
            fetchDischargeTemplates(response.data.animal_object.species);
          }
        })
        .catch(error => {
          if (axios.isCancel(error)) {
            console.log('Request canceled gracefully:', error.message);
          } else if (error.response)
          {
            setShowSystemError(true);
          }
        });
      };
      fetchMedRecord();
    }

    const fetchDischargeTemplates = async (species) => {
      // Fetch assignee data.
      await axios.get('/vet/api/dischargetemplate/?species=' + species, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let options = [];
          response.data.forEach(function(template) {
            options.push({value:template.id, label:template.name, description:template.description})
          });
          setDischargeTemplates(options);
        }
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('Request canceled gracefully:', error.message);
        } else if (error.response)
        {
          setShowSystemError(true);
        }
      });
    };

    const fetchAssignees = async () => {
      // Fetch assignee data.
      await axios.get('/accounts/api/user/?vet_doctors=true&organization=' + state.organization.id, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let options = [];
          response.data.forEach(function(person) {
            options.unshift({value: person.id, label: person.first_name + ' ' + person.last_name})
          });
          setAssigneeChoices(options);
        }
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('Request canceled gracefully:', error.message);
        } else if (error.response)
        {
          setShowSystemError(true);
        }
      });
    };
    fetchAssignees();

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [id]);

  return (
    <Formik
      initialValues={data}
      enableReinitialize={true}
      validationSchema={Yup.object({
        description: Yup.string().max(10000, 'Must be 10000 characters or less').required('Required'),
        open: Yup.string().nullable(),
        assignee: Yup.number().nullable().required('Required'),
      })}
      onSubmit={(values, { setSubmitting }) => {
        if (data.id) {
          axios.put('/vet/api/dischargesummary/' + data.id + '/', values)
          .then(response => {
            navigate('/' + organization + '/' + incident + '/vet/medrecord/' + data.medical_record);
          })
          .catch(error => {
            setShowSystemError(true);
          });
          setSubmitting(false);
        }
        else {
          axios.post('/vet/api/dischargesummary/', values)
          .then(response => {
            navigate('/' + organization + '/' + incident + '/vet/medrecord/' + medrecordid);
          })
          .catch(error => {
            setShowSystemError(true);
          });
          setSubmitting(false);
        }
      }}
    >
      {formikProps => (
        <Card border="secondary" className="mt-3">
          <Card.Header as="h5" className="ps-3">
            <span style={{ cursor: 'pointer' }} onClick={() => navigate('/' + organization + '/' + incident + '/vet/medrecord/' + medrecordid)} className="me-3"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="lg" inverse /></span>
            {!id ? "" : "Update "}Discharge Summary Form
          </Card.Header>
          <Patient animal={animalData} vet_request={null} organization={organization} incident={incident} medical_plan={data.medical_plan} />
          <Card.Body>
            <Form>
              <FormGroup>
                <Row className="gx-2">
                  <Col xs={"4"} className="pe-0">
                    <DropDown
                      label="Doctor*"
                      id="assignee"
                      name="assignee"
                      type="text"
                      options={assigneeChoices}
                      isClearable={false}
                      onChange={(instance) => {
                        formikProps.setFieldValue("assignee", instance === null ? '' : instance.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="mt-3 mb-3">
                  <Col xs={"8"}>
                    <label className="mb-2">Discharge Templates</label>
                    <Select
                      id="discharge_templates"
                      name="discharge_templates"
                      type="text"
                      styles={customStyles}
                      isMulti
                      options={dischargeTemplates}
                      value={dischargeTemplates.filter(choice => formikProps.values.discharge_templates.includes(choice.value))}
                      isClearable={true}
                      onChange={(instance) => {
                        let values = [];
                        instance && instance.forEach(option => {
                          values.push(option.value);
                        })
                        formikProps.setFieldValue("discharge_templates", instance === null ? [] : values);
                        let summary = formikProps.values.description;
                        if ((instance.length > formikProps.values.discharge_templates.length) && formikProps.values.description.length > 0) {
                          summary = summary + '<br /><br />';
                        }
                        instance.filter(option => !formikProps.values.discharge_templates.includes(option.value)).forEach(option => {
                          summary = summary + option.description;
                        })
                        formikProps.setFieldValue("description", summary);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="ps-0">
                  <Col>
                    <label className="mb-2">
                      Discharge Instructions*
                    </label>
                    <Editor value={formikProps.values.description || ''} onChange={(e) => formikProps.setFieldValue("description", e.target.value)} />
                  </Col>
                </Row>
                <Row className="mt-3 gx-2">
                  <Col>
                    <DateTimePicker
                      label="Discharged"
                      name="open"
                      id="open"
                      xs="4"
                      onChange={(date, dateStr) => {
                        formikProps.setFieldValue("open", dateStr || null)
                        if (dateStr) {
                          formikProps.setFieldValue("vet_status", 'Discharged');
                        }
                      }}
                      data-enable-time={true}
                      clearable={true}
                      value={formikProps.values.open||null}
                      now={true}
                      setFieldValue={formikProps.setFieldValue}
                      vet_status={'Discharged'}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col xs={6}>
                    <label>Vet Status</label>
                    <DropDown
                      id="vet_status"
                      type="text"
                      name="vet_status"
                      className="mb-2 mt-2"
                      options={changeStatusOptions}
                      isClearable={false}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Form>
          </Card.Body>
          <ButtonGroup>
            <Button type="button" className="btn btn-primary" onClick={() => { formikProps.submitForm() }}>{"Save"}</Button>
          </ButtonGroup>
        </Card>
      )}
    </Formik>
  );
};

export default DischargeSummaryForm;
